import React, { useState } from 'react';
import Header from "../../components/Header";
import StarBackground from "../../components/StarBackground";
import Timeline from "../../components/Timeline";
import ExeCore from "../../components/ExeCore";
import Controls from "../../components/Controls";
import Character from "../../components/Character";
import Planet from "../../components/Planet";
import {useNavigate} from "react-router-dom";
import config from './sentencesConfig';


export default function Sentences() {
    const navigate = useNavigate();
    const overlayImage = `/assets/images/sentencesImages/test.png`;

    // Mock useRecorder hook
    const [isRecording, setIsRecording] = useState(false);

    const startRecording = () => {
        setIsRecording(true);
    };

    const stopRecording = () => {
        setIsRecording(false);
    };

    const handleValidate = () => {
        navigate('/exercise/sentences/main/1');
    };

    return (
        <div className="sentences-wrapper">
            <Header color={config.headerColor} />

            <StarBackground imagePath={config.planetBackground} />

            <Timeline current={0} total={config.totalLevels || 14} />

            <ExeCore image={config.marsImage} size={config.marsSize} />
            <ExeCore image={overlayImage} size={config.marsSize} className="overlay-core" />

            <Controls
                colors={config.controlColors}
                onRepeat={() => console.log('Repeat')} // This prop is not currently used by Controls.js
                onStartRecording={startRecording} // Pass the explicit startRecording function
                onStopRecording={stopRecording}   // Pass the explicit stopRecording function
                onValidate={handleValidate}
                context={'1'} //Sostituire con test
                recording={isRecording} // Pass isRecording for the microphone visual feedback
                recordingMode="post-playback" // *** Set this prop for the desired behavior ***
                disableUpload={true}
            />
            <Character name="Mars" position='left' isActive={false} />
            <Character
                name={config.character}
                position='right'
                isActive={false}
            />
            <Planet image={config.planetImage} />
        </div>
    );
}
